import { LetterSource } from "src/js/stores/letter/store";
import ROUTES from "src/js/router/routes";
import { SelectionType } from "../../map/store";
import { letterStore } from "../store";

export const getBackRoute = () => {
  const { source, selectedSiteIds } = letterStore;
  switch (source) {
    case LetterSource.SiteCard:
      return {
        name: ROUTES.SITES,
        query: {
          card_page: "letters",
          site_id: selectedSiteIds?.[0],
        },
      };
    case LetterSource.Pipeline:
      return { name: ROUTES.SITES };
    case LetterSource.Workbench:
      return {
        name: ROUTES.MAP,
        query: selectedSiteIds
          ? {
              selectionType: SelectionType.SITE,
              selectionId: selectedSiteIds[0],
              workbenchRoute: "/management/letters",
            }
          : {},
      };
    default:
      return { name: ROUTES.SITES };
  }
};
